export default function simpleRnd(): string {
  const rnd = Math.random();
  const floats = rnd.toString().split(".")[1];
  const t = Date.now();
  return `${t}-${floats}`;
}
